import { useProperty } from "../context/PropertyContext";
import { IP } from '../configuracion.js'; // Ajusta la ruta si es necesario
// Delay function for retries
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const handlePedidoCore = async (pedidoData, mostrarMensaje, property) => {
  const effectiveProperty = property || "template";
  const url = `${IP}/tavpos/backend/insertar_pedido.php?property=${encodeURIComponent(effectiveProperty)}`; // Changed to HTTP
  const maxRetries = 3;
  let lastError;

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      console.log(`Enviando pedido a: ${url} (Intento ${attempt})`, "Datos:", JSON.stringify(pedidoData, null, 2));
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "X-Property": effectiveProperty,
          "Accept": "application/json",
        },
        body: JSON.stringify(pedidoData),
        credentials: "omit",
      });

      if (!response.ok) {
        const text = await response.text();
        console.error("Respuesta del servidor (no OK):", {
          status: response.status,
          statusText: response.statusText,
          responseText: text,
          url,
          attempt,
          headers: Object.fromEntries(response.headers.entries()),
        });
        throw new Error(`Error ${response.status}: ${response.statusText} - ${text}`);
      }

      const responseText = await response.text();
      console.log("Respuesta del servidor (texto):", responseText);

      if (!responseText.trim()) {
        throw new Error("La respuesta del servidor está vacía.");
      }

      let result;
      try {
        result = JSON.parse(responseText);
      } catch (jsonError) {
        console.error("Error al parsear la respuesta JSON:", jsonError, "Respuesta:", responseText);
        throw new Error("La respuesta del servidor no es un JSON válido.");
      }

      if (!result.success) {
        throw new Error(result.message || "El pedido no se procesó correctamente en el servidor.");
      }

      mostrarMensaje("✅ Pedido enviado correctamente.");
      return result;
    } catch (error) {
      lastError = {
        message: error.message || "Error desconocido",
        name: error.name,
        stack: error.stack,
        url,
        requestBody: JSON.stringify(pedidoData, null, 2),
        cause: error.cause || "No cause provided",
        attempt,
      };
      console.error(`Error en intento ${attempt} para ${url}:`, lastError);

      if (attempt < maxRetries) {
        console.log(`Reintentando en 1 segundo...`);
        await delay(1000); // Wait 1 second before retrying
      }
    }
  }

  console.error("Todos los intentos fallaron. Último error:", lastError);
  mostrarMensaje(`❌ Hubo un error al enviar el pedido: ${lastError.message}`);
  throw lastError || new Error("No se pudo conectar con el servidor.");
};

export const useHandlePedido = () => {
  const { property } = useProperty();
  const effectiveProperty = property || "template";

  const handlePedido = async (pedidoData, mostrarMensaje) => {
    try {
      return await handlePedidoCore(pedidoData, mostrarMensaje, effectiveProperty);
    } catch (error) {
      console.error("Error en useHandlePedido:", error);
      throw error;
    }
  };

  return handlePedido;
};